module.exports = __webpack_public_path__ + "static/media/Livelli_CEFR.08db05a7.pdf";